import React from 'react';
import ContentBuilder from '../../core/ContentBuilder';
import styles from './ScheduleList.module.scss';

interface ScheduleItem {
  date?: string;
  heading: string;
  text?: string;
  content?: any[];
  note?: string;
}

interface ScheduleGroup {
  title: string;
  subtitle?: string;
  items: ScheduleItem[];
}

interface ScheduleListProps {
  data: ScheduleGroup[];
}

export class ScheduleList extends React.Component<ScheduleListProps> {
  render() {
    const data = this.props['data'];
    return (
      <dl className={styles['schedule-list']}>
        {data?.map((group, i) => (
          <div key={i} className={styles['group']}>
            <dt className={styles['group-header']}>
              <div className={styles['group-title']}>{group.title}</div>
              {group.subtitle && (
                <div className={styles['group-subtitle']}>{group.subtitle}</div>
              )}
            </dt>
            <dd className={styles['items']}>
              <dl>
                {group.items?.map((item, j) => (
                  <div key={j} className={styles['item']}>
                    {item.date && (
                      <dt className={styles['item-date']}>{item.date}</dt>
                    )}
                    <dd className={styles['item-heading']}>
                      {ContentBuilder.build(item.heading, {}, styles)}
                    </dd>
                    {item.text !== undefined && (
                      <dd className={styles['item-body']}>
                        {ContentBuilder.build(item.text, {}, styles)}
                      </dd>
                    )}
                    {item.content !== undefined && (
                      <dd className={styles['item-content']}>
                        {ContentBuilder.build(item.content, {}, styles)}
                      </dd>
                    )}
                    {item.note && (
                      <dd className={styles['item-note']}>
                        {ContentBuilder.build(item.note, {}, styles)}
                      </dd>
                    )}
                  </div>
                ))}
              </dl>
            </dd>
          </div>
        ))}
      </dl>
    );
  }
}
